module.exports = __webpack_public_path__ + "media/images/gallery/aurorae_on-546c6871abecacc128454f3fe37e50bc.gif";